import { UserRole } from './UserRole';

// Interfaces for site/authorize

export interface AuthToken {
    authorization_code: string;
    expires_at: string;
}

export interface SiteAuthorize {
    data: AuthToken;
}

// Interfaces for site/accesstoken

export interface UserToken {
    access_token: string;
    expires_at: string;
}

export interface SiteAccesstoken {
    data: UserToken;
}

// Interfaces for user/me

export interface UserMe {
    id: number;
    username: string;
    status: number;
    superadmin: number;
    email: string;
    user_type_id: UserRole;
}

// Interfaces for user/view

export interface Adresse {
    id: number | null;
    numero: string;
    rue: string;
    complement: string;
    ville: string;
    code_postal: string;
}

export interface Responsable {
    id: number;
    nom: string;
    prenom: string;
    lien: string;
    adresse: Adresse;
    date_naissance: string;
    email: string;
    telephone: string;
}

export interface ProfileInfo {
    id: number;
    nom: string;
    prenom: string;
    telephone: string;
    photo_profil: string;
    taille: string;
    pointure: string;
    date_naissance: string;
    adresse: Adresse;
    responsable: Responsable | null;
}

export interface UserView {
    id: number;
    username: string;
    status: number;
    superadmin: number;
    email: string;
    media: Media[];
    events: Event[];
    userProfile: ProfileInfo | null;
    user_type_id: UserRole;
    tags: Tag[];
}

// Interfaces for site/register

export interface LineUser {
    id: number;
    username: string;
    status: number;
    superadmin: number;
    email: string;
}

export interface ListeUser {
    data: {
        listeUser: LineUser[];
    };
}
export interface SiteRegister {
    status: boolean;
    data: {
        id: number;
        username: string;
        status: number;
        email: string;
        user_type_id: UserRole;
    };
}

// Interfaces for courses

export interface Discipline {
    id: number;
    intitule: string;
    description: string;
}

export interface Niveau {
    id: number;
    intitule: string;
    description: string;
}

export interface Course {
    id: number;
    discipline: Discipline;
    adresse: Adresse;
    niveau: Niveau;
    details: string;
    horaire: string;
    jour: string;
    status: number;
    tag: Tag;
}

// Interfaces for type_event
export interface TypeEvent {
    id: number;
    nom_type: string;
}

// Interfaces for Frais
export interface Frais {
    id: number;
    intitule: string;
    user_id: number;
    event_id: number;
    montant: string;
}

// Interfaces for event
export interface Event {
    id: number;
    intitule: string;
    type_event: TypeEvent;
    adresse: Adresse;
    cours: Course | null;
    date_heure_debut: Date;
    date_heure_fin: Date;
    description: string;
    budget: string;
    media: Media[];
}

export interface Presence {
    id: number;
    user_id: number;
    event_id: number;
    presence: boolean;
    user: UserView;
}

// Interfaces for subscription
export enum SubscriptionState {
    TERMINEE,
    A_VALIDER,
    EN_COURS,
}

export enum ModeReglement {
    UNDEFINED,
    ESPECES,
    CHEQUE,
}

export interface Annee {
    id: number;
}

export interface Subscription {
    id: number;
    annee: Annee;
    user: UserMe;
    mode_reglement: ModeReglement;
    nombre_cheque: string | null;
    etat: SubscriptionState;
}

export interface SubscriptionPart1 {
    nom: string;
    prenom: string;
    date_naissance: string;
    adresse: Adresse;
    telephone: string;
    pointure: string;
    taille: string;
    responsable: Responsable | null;
}

export interface SubscriptionPart2 {
    cours: number[];
    mode_reglement: ModeReglement;
    nombre_cheque: string | null;
}

export interface SubscriptionPart3 {
    photo_profil: File;
    certificat_medical: File;
    attestation_assurance: File;
    valide: boolean;
}

export enum TypeFile {
    ATTESTATIONASSURANCE = 2,
    CERTIFICATMEDICAL = 1,
    FORMULAIREADHESION = 3,
}

export interface Fichiers {
    id: number;
    user_id: number;
    type_file: TypeFile;
    nom: string;
    lien: string;
    created_at: number;
}

// Interfaces for media
export enum Type_Media {
    VIDEO = 2,
    PHOTO = 1,
}

export interface Media {
    id: number;
    user_id: number;
    type_media_id: Type_Media;
    nom: string;
    description: string;
    lien: string;
    afficher: number;
    annee_id: number;
    created_at: string;
    event_id: number | null;
    user: UserView;
}

export interface EventProfil {
    id: number;
    intitule: string;
    adresse: Adresse;
    description: string;
}
export interface Tarif {
    id: number;
    libelle: string;
    valeur: string;
}
export interface Decharges {
    id: number;
    contenu_droit: string;
    contenu_decharge: string;
}

// Interfaces for tags
export interface Tag {
    nom: string;
    id: number;
}


// WEBPACK FOOTER //
// ./src/types/ServerRequests.tsx